import $ from 'jquery'

module.exports = {
	namespace: 'default',
	beforeEnter() {

	},
	afterEnter() {

	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
